var _style, _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _g, _g2, _g3, _g4, _path2, _g5, _g6, _g7, _g8, _g9, _path3, _rect22, _polygon, _polygon2, _path4, _rect23, _path5, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 227.6 90.1",
    style: {
      enableBackground: "new 0 0 227.6 90.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6FA851;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 109.8,
    y: 25.7,
    className: "st0",
    width: 19,
    height: 3.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 107.2,
    y: 24.8,
    className: "st0",
    width: 24,
    height: 1.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107.2,
    y: 18.2,
    className: "st0",
    width: 24,
    height: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.6,71.9h-18.7c-3,0-5.4-2.4-5.4-5.4V36.1c0-4.5,3.6-8.1,8.1-8.1h13.2c4.5,0,8.1,3.6,8.1,8.1v30.4 C134,69.5,131.6,71.9,128.6,71.9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 118.1,
    y: 18.2,
    className: "st0",
    width: 1,
    height: 7.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 113.9,
    y: 18.2,
    className: "st0",
    width: 1,
    height: 7.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 115.3,
    y: 18.2,
    className: "st0",
    width: 1,
    height: 7.9
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 116.7,
    y: 18.2,
    className: "st0",
    width: 1,
    height: 7.9
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 109.8,
    y: 18.2,
    className: "st0",
    width: 1,
    height: 7.9
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 119.5,
    y: 18.2,
    className: "st0",
    width: 1,
    height: 7.9
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 112.5,
    y: 18.2,
    className: "st0",
    width: 1,
    height: 7.9
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 108.4,
    y: 18.2,
    className: "st0",
    width: 1,
    height: 7.9
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 111.1,
    y: 18.2,
    className: "st0",
    width: 1,
    height: 7.9
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 129.2,
    y: 18.2,
    className: "st0",
    width: 1,
    height: 7.9
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 127.8,
    y: 18.2,
    className: "st0",
    width: 1,
    height: 7.9
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 126.4,
    y: 18.2,
    className: "st0",
    width: 1,
    height: 7.9
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 120.8,
    y: 18.2,
    className: "st0",
    width: 1,
    height: 7.9
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 130.5,
    y: 18.2,
    className: "st0",
    width: 0.7,
    height: 7.9
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 107.2,
    y: 18.2,
    className: "st0",
    width: 0.7,
    height: 7.9
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 122.2,
    y: 18.2,
    className: "st0",
    width: 1,
    height: 7.9
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 123.6,
    y: 18.2,
    className: "st0",
    width: 1,
    height: 7.9
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 18.2,
    className: "st0",
    width: 1,
    height: 7.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.1,86.3c-0.7,0.6-1.6,0.9-2.6,0.9c-2.1,0-3.4-1.4-3.4-3.6c0-2.3,1.5-3.5,3.5-3.5c0.9,0,1.7,0.2,2.4,0.6 c0.1,0.6,0.1,1.2,0.1,1.7c-0.2,0.1-0.4,0.1-0.6,0.1l-0.2-1.3c-0.5-0.3-1-0.4-1.6-0.4c-1.5,0-2.6,1.1-2.6,2.9c0,1.7,1,2.8,2.5,2.8 c0.8,0,1.5-0.2,2.1-0.9h0.4C104.1,85.8,104.1,86.1,104.1,86.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.9,87.1c-0.2,0-0.5,0-0.7,0c-0.6,0-0.7-0.2-0.7-0.8V86c-0.3,0.6-0.9,1.2-1.9,1.2c-0.9,0-1.5-0.5-1.5-1.4 c0-1.1,1-1.6,2.1-1.6c0.4,0,0.8,0,1.1,0.1v-0.6c0-0.8-0.3-1.1-1.1-1.1c-0.4,0-0.8,0.1-1.1,0.2l-0.1,0.7c-0.2,0.1-0.4,0.1-0.6,0 c-0.1-0.4-0.1-0.8-0.1-1.1c0.5-0.2,1.2-0.5,1.9-0.5c1.1,0,1.8,0.3,1.8,1.8v2.6l0.8,0.1C109.9,86.7,109.9,86.9,109.9,87.1z  M108.4,85.3v-0.4c-0.3-0.1-0.7-0.1-1.1-0.1c-0.8,0-1.4,0.3-1.4,1c0,0.4,0.2,0.8,0.9,0.8C107.6,86.6,108.3,86,108.4,85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.8,84.6c0,1.6-0.9,2.6-2.3,2.6c-0.8,0-1.4-0.3-1.7-0.8v2.2l1.1,0.1c0,0.2,0,0.3,0,0.5h-2.7 c0-0.2,0-0.4,0-0.6l0.8,0v-5.9l-0.8,0c0-0.2,0-0.4,0-0.6l1.5-0.1l0,0.9c0.4-0.5,1-0.9,1.8-0.9C114.8,82,115.8,83,115.8,84.6z  M114.9,84.6c0-1.2-0.6-2-1.6-2c-0.8,0-1.6,0.6-1.6,1.9v0c0,1.2,0.7,1.9,1.6,1.9C114.1,86.6,114.9,86,114.9,84.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.8,87.2c-0.8,0-1.4-0.2-2-0.5c-0.1-0.3-0.1-0.9-0.1-1.2c0.2,0,0.4,0,0.6,0l0.1,0.8 c0.3,0.2,0.7,0.3,1.3,0.3c0.8,0,1.1-0.3,1.1-0.7c0-0.5-0.5-0.7-1.3-0.9c-1-0.3-1.8-0.6-1.8-1.5c0-0.7,0.6-1.3,1.9-1.3 c0.6,0,1.3,0.1,1.8,0.4h0c0,0.3,0.1,0.8,0,1.2c-0.2,0-0.3,0.1-0.5,0l-0.2-0.8c-0.4-0.2-0.8-0.2-1.1-0.2c-0.8,0-1.1,0.3-1.1,0.7 c0,0.5,0.6,0.7,1.5,1c0.9,0.3,1.6,0.5,1.7,1.5C120.7,86.7,120,87.2,118.8,87.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.9,87.1l-1.5,0.1l0-1c-0.4,0.5-1.1,1-1.8,1c-1,0-1.5-0.5-1.5-1.8v-2.7l-0.7,0c0-0.2,0-0.4,0-0.6l1.5-0.1 v3.3c0,0.8,0.2,1.2,0.9,1.2s1.6-0.8,1.6-1.5v-2.3l-0.8,0c0-0.2,0-0.4,0-0.6l1.6-0.1v4.5l0.8,0C127,86.7,127,86.9,126.9,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.2,87.1h-2.4c0-0.2,0-0.4,0-0.6l0.8,0v-5.9l-0.8,0c0-0.2,0-0.4,0-0.6l1.6-0.1v6.6l0.9,0.1 C130.2,86.8,130.2,86.9,130.2,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.2,84.8h-3.7c0,1,0.6,1.8,1.7,1.8c0.5,0,1-0.1,1.5-0.6c0.1,0,0.2,0,0.3,0c0,0.3,0,0.4,0,0.7 c-0.7,0.5-1.2,0.6-2,0.6c-1.4,0-2.4-1-2.4-2.6c0-1.6,1-2.6,2.3-2.6c1.6,0,2.2,1,2.2,2.4C135.2,84.6,135.2,84.7,135.2,84.8z  M131.5,84.1h2.9c0-0.9-0.5-1.5-1.4-1.5C132.2,82.7,131.6,83.2,131.5,84.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.1,87.2c-0.8,0-1.4-0.2-2-0.5c-0.1-0.3-0.1-0.9-0.1-1.2c0.2,0,0.4,0,0.6,0l0.1,0.8 c0.3,0.2,0.7,0.3,1.3,0.3c0.8,0,1.1-0.3,1.1-0.7c0-0.5-0.5-0.7-1.3-0.9c-1-0.3-1.8-0.6-1.8-1.5c0-0.7,0.6-1.3,1.9-1.3 c0.6,0,1.3,0.1,1.8,0.4h0c0,0.3,0.1,0.8,0,1.2c-0.2,0-0.3,0.1-0.5,0l-0.2-0.8c-0.4-0.2-0.8-0.2-1.1-0.2c-0.8,0-1.1,0.3-1.1,0.7 c0,0.5,0.6,0.7,1.5,1c0.9,0.3,1.6,0.5,1.7,1.5C140.1,86.7,139.4,87.2,138.1,87.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.9,81.7c-0.2,0-0.4,0-0.6,0l-0.1-1.3l-1.7,0v5.7l0.9,0c0,0.2,0,0.4,0,0.6H1.8c0-0.2,0-0.4,0-0.6L2.7,86v-5.6 l-1.7,0l-0.1,1.3c-0.2,0-0.4,0-0.6,0c0-0.6,0-1.3,0-1.9h5.6C6,80.4,6,81,5.9,81.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.1,86.7H6.7c0-0.2,0-0.4,0-0.6l0.8,0v-3.8l-0.8,0c0-0.2,0-0.4,0-0.6l1.6-0.1v4.5l0.9,0.1 C9.1,86.3,9.1,86.5,9.1,86.7z M7.3,80.5c0-0.3,0-0.6,0-0.9c0.3,0,0.6,0,1,0c0,0.3,0,0.7,0,0.9C7.9,80.5,7.6,80.5,7.3,80.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.5,86.7H14v-3.1c0-0.9-0.2-1.3-0.9-1.3c-0.9,0-1.7,0.7-1.7,1.5v2.3l0.8,0.1c0,0.2,0,0.3,0,0.5H9.8 c0-0.2,0-0.4,0-0.6l0.8-0.1v-3.8l-0.8,0c0-0.2,0-0.4,0-0.6l1.5-0.1l0,0.9c0.4-0.5,1.1-0.9,1.9-0.9c1.1,0,1.5,0.5,1.5,1.8v2.7 l0.8,0.1C15.5,86.3,15.5,86.5,15.5,86.7z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.5,86.1c-0.7,0.5-1.2,0.6-1.9,0.6c-1.5,0-2.4-1-2.4-2.6c0-1.5,0.9-2.6,2.4-2.6c0.5,0,1.1,0.1,1.7,0.4 c0.1,0.4,0.1,1,0.1,1.3l-0.5,0.1l-0.2-0.9c-0.3-0.1-0.7-0.2-1.1-0.2c-0.9,0-1.6,0.7-1.6,1.9c0,1.1,0.6,1.9,1.7,1.9 c0.5,0,1-0.1,1.5-0.6h0.3C20.5,85.7,20.5,85.9,20.5,86.1z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.6,86.3c-0.3,0.3-0.8,0.4-1.4,0.4c-0.8,0-1.4-0.3-1.4-1.3v-3.1h-0.7c0-0.2,0-0.4,0-0.6l0.7-0.1l0.1-1.3 c0.2,0,0.4,0,0.6,0v1.3h1.9c0,0.2,0,0.4,0,0.7h-1.9v3c0,0.6,0.2,0.8,0.7,0.8c0.3,0,0.7-0.1,1-0.4c0.1,0,0.2,0,0.2,0 C24.6,86,24.6,86,24.6,86.3z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.7,86.7l-1.5,0.1l0-1c-0.4,0.5-1.1,1-1.8,1c-1,0-1.5-0.5-1.5-1.8v-2.7l-0.7,0c0-0.2,0-0.4,0-0.6l1.5-0.1 v3.3c0,0.8,0.2,1.2,0.9,1.2s1.6-0.8,1.6-1.5v-2.3l-0.8,0c0-0.2,0-0.4,0-0.6l1.6-0.1v4.5l0.8,0C30.7,86.3,30.7,86.5,30.7,86.7z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.2,82.7c-0.2,0.1-0.4,0.1-0.6,0.1l-0.4-0.6C33.5,82.4,33,83,33,84.1v2l1,0.1c0,0.2,0,0.3,0,0.5h-2.6 c0-0.2,0-0.4,0-0.6l0.8-0.1v-3.8l-0.8,0c0-0.2,0-0.4,0-0.6l1.5-0.1l0.1,0.9c0.3-0.6,0.8-0.9,1.5-0.9c0.2,0,0.5,0,0.6,0.1 C35.2,82.1,35.2,82.4,35.2,82.7z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.4,84.3h-3.7c0,1,0.6,1.8,1.7,1.8c0.5,0,1-0.1,1.5-0.6c0.1,0,0.2,0,0.3,0c0,0.3,0,0.4,0,0.7 c-0.7,0.5-1.2,0.6-2,0.6c-1.4,0-2.4-1-2.4-2.6c0-1.6,1-2.6,2.3-2.6c1.6,0,2.2,1,2.2,2.4C40.4,84.1,40.4,84.2,40.4,84.3z M36.7,83.7 h2.9c0-0.9-0.5-1.5-1.4-1.5C37.4,82.2,36.8,82.7,36.7,83.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.4,86.7c-0.8,0-1.4-0.2-2-0.5c-0.1-0.3-0.1-0.9-0.1-1.2c0.2,0,0.4,0,0.6,0l0.1,0.8c0.3,0.2,0.7,0.3,1.3,0.3 c0.8,0,1.1-0.3,1.1-0.7c0-0.5-0.5-0.7-1.3-0.9c-1-0.3-1.8-0.6-1.8-1.5c0-0.7,0.6-1.3,1.9-1.3c0.6,0,1.3,0.1,1.8,0.4h0 c0,0.3,0.1,0.8,0,1.2c-0.2,0-0.3,0.1-0.5,0l-0.2-0.8c-0.4-0.2-0.8-0.2-1.1-0.2c-0.8,0-1.1,0.3-1.1,0.7c0,0.5,0.6,0.7,1.5,1 c0.9,0.3,1.6,0.5,1.7,1.5C45.3,86.2,44.6,86.7,43.4,86.7z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.2,86.7h-0.9c-1.1,0-1.8-1.6-2.3-2.8h-0.2h-1.3V86l1.1,0.1c0,0.2,0,0.4,0,0.6h-2.8c0-0.2,0-0.4,0-0.6 l0.8-0.1v-5.6l-0.8,0c0-0.2,0-0.4,0-0.6h3c1.8,0,2.6,0.7,2.6,2c0,1.2-0.6,1.8-1.6,2c0.4,1,1.1,2.1,1.9,2.2l0.5,0 C207.3,86.3,207.3,86.5,207.2,86.7z M205.6,81.8c0-0.9-0.5-1.4-1.8-1.4h-1.3v2.8h1.2C205.1,83.2,205.6,82.8,205.6,81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213,84.8c0,1.3-1,1.9-2.8,1.9c-0.8,0-1.7-0.2-2.3-0.5c-0.1-0.7-0.1-1.3-0.1-1.6c0.2,0,0.4,0,0.7,0l0.2,1.1 c0.5,0.2,0.9,0.3,1.5,0.3c1.2,0,1.9-0.4,1.9-1.2c0-0.8-0.8-1-2-1.4c-1.4-0.5-2.2-0.8-2.2-2c0-1,0.8-1.8,2.6-1.8 c0.7,0,1.5,0.1,2.2,0.6c0,0.7,0,1.2,0,1.6c-0.2,0-0.4,0.1-0.6,0l-0.2-1.2c-0.4-0.2-0.9-0.3-1.4-0.3c-1.1,0-1.7,0.5-1.7,1.1 c0,0.7,0.7,1,1.8,1.3C211.9,83.1,213,83.4,213,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M220.7,83.2c0,2.2-1.3,3.5-3.4,3.5c-2.1,0-3.4-1.3-3.4-3.5c0-2.2,1.3-3.6,3.4-3.6 C219.4,79.6,220.7,81,220.7,83.2z M214.8,83.2c0,1.7,1,2.8,2.5,2.8c1.5,0,2.5-1.1,2.5-2.8c0-1.7-1-2.8-2.5-2.8 C215.8,80.4,214.8,81.5,214.8,83.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.8,86.7c-0.8,0-1.4-0.2-2-0.5c-0.1-0.3-0.1-0.9-0.1-1.2c0.2,0,0.4,0,0.6,0l0.1,0.8 c0.3,0.2,0.7,0.3,1.3,0.3c0.8,0,1.1-0.3,1.1-0.7c0-0.5-0.5-0.7-1.3-0.9c-1-0.3-1.8-0.6-1.8-1.5c0-0.7,0.6-1.3,1.9-1.3 c0.6,0,1.3,0.1,1.8,0.4h0c0,0.3,0.1,0.8,0,1.2c-0.2,0-0.3,0.1-0.5,0l-0.2-0.8c-0.4-0.2-0.8-0.2-1.1-0.2c-0.8,0-1.1,0.3-1.1,0.7 c0,0.5,0.6,0.7,1.5,1c0.9,0.3,1.6,0.5,1.7,1.5C225.7,86.2,225,86.7,223.8,86.7z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.4,70.1c0,0.7,0.6,1.2,1.3,1.2s1.3-0.5,1.3-1.2v-1.7h-2.6V70.1z"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 209.2,
    y: 5,
    className: "st0",
    width: 8.8,
    height: 2.4
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "211.8,67.6 215.4,67.6 215.4,7.7 211.9,7.7 211.9,9.3 211.8,9.3 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "215.6,9.3 215.6,67.9 215.5,67.9 215.4,67.9 211.8,67.9 211.7,67.9 211.6,67.9 211.6,9.3 210.7,9.3  210.7,49.8 210.7,51.1 210.7,69 216.7,69 216.7,51.1 216.7,49.8 216.7,9.3 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.4,8.9c0-2-1.6-3.7-3.7-3.7c-2,0-3.7,1.6-3.7,3.7v7.7h7.3V8.9z"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 14.8,
    y: 22.5,
    className: "st0",
    width: 15.9,
    height: 8.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.4,71.9H15.1c-1.7,0-3-1.4-3-3V39.2c0-5,4-9,9-9h3.4c5,0,9,4,9,9v29.7C33.5,70.5,32.1,71.9,30.4,71.9"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 16.6,
    className: "st0",
    width: 0.6,
    height: 6.1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 19.4,
    y: 16.6,
    className: "st0",
    width: 0.6,
    height: 6.1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3,
    y: 16.6,
    className: "st0",
    width: 0.6,
    height: 6.1
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2,
    y: 16.6,
    className: "st0",
    width: 0.6,
    height: 6.1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 16.6,
    className: "st0",
    width: 0.6,
    height: 6.1
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 22.9,
    y: 16.6,
    className: "st0",
    width: 0.6,
    height: 6.1
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6,
    y: 16.6,
    className: "st0",
    width: 0.6,
    height: 6.1
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16.6,
    className: "st0",
    width: 0.6,
    height: 6.1
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7,
    y: 16.6,
    className: "st0",
    width: 0.6,
    height: 6.1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8,
    y: 16.6,
    className: "st0",
    width: 0.6,
    height: 6.1
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 16.6,
    className: "st0",
    width: 0.6,
    height: 6.1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1,
    y: 16.6,
    className: "st0",
    width: 0.6,
    height: 6.1
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7,
    y: 16.6,
    className: "st0",
    width: 0.6,
    height: 6.1
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 29.7,
    y: 16.6,
    className: "st0",
    width: 0.4,
    height: 6.1
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3,
    y: 16.6,
    className: "st0",
    width: 0.4,
    height: 6.1
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 24.6,
    y: 16.6,
    className: "st0",
    width: 0.6,
    height: 6.1
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 25.4,
    y: 16.6,
    className: "st0",
    width: 0.6,
    height: 6.1
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 26.3,
    y: 16.6,
    className: "st0",
    width: 0.6,
    height: 6.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormsIcon);
export default __webpack_public_path__ + "static/media/forms-icon.3df915fc765db9f734cfd03d920f3f9d.svg";
export { ForwardRef as ReactComponent };